import ApiService from './api.service';

export interface ParkedTask {
  id: string;
  branch_name: string;
  project_name: string;
  task_name: string | null;
  description: string | null;
  created_by_label: string;
  created_at: string;
  commit_hash: string | null;
}

export interface ListParkedTasksResult {
  /** Platform stack this API serves (e.g. "dev-beta", "production"). */
  stack: string;
  /** Tenant slug — how jimi-desktop keys the matching client project. */
  tenant_slug: string;
  tasks: ParkedTask[];
}

class ParkedTaskService {
  async list(): Promise<ListParkedTasksResult> {
    return (await ApiService.getInstance().request('GET', '/parked-tasks')) as ListParkedTasksResult;
  }
}

export const parkedTaskService = new ParkedTaskService();

/**
 * Deep link that opens a parked task in jimi-desktop and unparks it.
 *
 * Canary and stable jimi builds register distinct URL schemes so they can be
 * installed side-by-side; the canary build is paired with the dev-beta stack, so
 * dev-beta emits `jimi-canary://` and every other stack emits the stable `jimi://`.
 * `stack` + `tenant` let jimi resolve the right local client project.
 */
export function unparkDeepLink(stack: string, tenantSlug: string, parkedTaskId: string): string {
  const scheme = stack === 'dev-beta' ? 'jimi-canary' : 'jimi';
  const params = new URLSearchParams({ stack, tenant: tenantSlug });
  return `${scheme}://unpark/${parkedTaskId}?${params.toString()}`;
}
